/* eslint-disable prettier/prettier */
import React from 'react';

let openAutoCompleteCount = 0;

const lockBodyScroll = () => {
    openAutoCompleteCount += 1;

    if (openAutoCompleteCount === 1) {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
};

const unlockBodyScroll = () => {
    openAutoCompleteCount = Math.max(0, openAutoCompleteCount - 1);

    if (openAutoCompleteCount === 0) {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
    }
};

/* =========================
   MUI v4 Autocomplete
   (@material-ui/lab)
========================= */

import { Autocomplete as AutocompleteV4, AutocompleteProps as AutocompletePropsV4 } from '@material-ui/lab';

export type MuiAutoCompleteV4Props<
    T,
    Multiple extends boolean | undefined = undefined,
    DisableClearable extends boolean | undefined = undefined,
    FreeSolo extends boolean | undefined = undefined,
> = AutocompletePropsV4<T, Multiple, DisableClearable, FreeSolo>;

export const MuiAutoComplete = <
    T,
    Multiple extends boolean | undefined = undefined,
    DisableClearable extends boolean | undefined = undefined,
    FreeSolo extends boolean | undefined = undefined,
>(
    props: MuiAutoCompleteV4Props<T, Multiple, DisableClearable, FreeSolo>,
) => {
    const { onOpen, onClose, ...rest } = props;

    return (
        <AutocompleteV4
            {...rest}
            onOpen={(event) => {
                lockBodyScroll();
                onOpen?.(event);
            }}
            onClose={(event, reason) => {
                unlockBodyScroll();
                onClose?.(event, reason);
            }}
        />
    );
};

/* =========================
   MUI v5 Autocomplete
   (@mui/material)
========================= */

import { Autocomplete as AutocompleteV5, AutocompleteProps as AutocompletePropsV5 } from '@mui/material';

export type MuiAutoCompleteV5Props<
    T,
    Multiple extends boolean | undefined = undefined,
    DisableClearable extends boolean | undefined = undefined,
    FreeSolo extends boolean | undefined = undefined,
> = AutocompletePropsV5<T, Multiple, DisableClearable, FreeSolo>;

export const MuiAutoCompleteV5 = <
    T,
    Multiple extends boolean | undefined = undefined,
    DisableClearable extends boolean | undefined = undefined,
    FreeSolo extends boolean | undefined = undefined,
>(
    props: MuiAutoCompleteV5Props<T, Multiple, DisableClearable, FreeSolo>,
) => {
    const { onOpen, onClose, ...rest } = props;

    React.useEffect(() => {
        return () => {
            openAutoCompleteCount = 0;
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        };
    }, []);

    return (
        <AutocompleteV5
            {...rest}
            onOpen={(event) => {
                lockBodyScroll();
                onOpen?.(event);
            }}
            onClose={(event, reason) => {
                unlockBodyScroll();
                onClose?.(event, reason);
            }}
        />
    );
};
